module.exports = __webpack_public_path__ + "img/preview.56e76ce6.jpg";